import React from 'react';
import styled from 'styled-components';
import { useIsMobile } from '../App.tsx';

interface OptionData {
  label: string;
  hint?: string;
}

interface ThreeOptionSliderProps {
  options: OptionData[]; // [{ label: 'Day', hint: '+5 tasks' }, ...]
  value: string;
  onChange: (value: string) => void;
}

const SliderWrapper = styled.div`
  width: 100%;
  background: #0e0e10;
  border-radius: 38px;
  display: flex;
  position: relative;
  min-height: 44px;
  overflow: hidden;
  gap: 10px;
     @media (max-width: 768px) {
    padding: 4px;
    min-height: 40px;
    width: auto;
    border-radius: 45px;
    gap: 10px;
  }
`;

const Option = styled.button<{ active?: boolean }>`
  flex: 1;
  background: transparent;
  border: none;
  cursor: pointer;
  font-weight: 500;
  color: ${({ active }) => (!active ? 'gray' : 'white')};
  z-index: 2;
  position: relative;
  font-family: 'Onest', sans-serif;
  transition: color 0.3s;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: center;

     @media (max-width: 768px) {
     flex-direction: column;
     align-items: space-around;
     gap: 0;
    font-size: 12px;
  }

  span.hint {
    color: ${({ active }) => (active ? 'gray' : '#7C808680')};

  }
`;

const SliderHighlight = styled.div<{ index: number }>`
  position: absolute;
  top: 0;
  left: ${({ index }) => index * 33.3333}%;
  width: 33.3333%;
  height: 100%;
  background: #171717;
  border-radius: 38px;
     @media (max-width: 768px) {
       left: ${({ index }) =>  Math.min(65.66, Math.max(index * 33.3333, 1))}%;
    height: 80%;
    top: 10%;
  }
  transition: left 0.3s;
  z-index: 1;
`;

export const ThreeOptionSlider: React.FC<ThreeOptionSliderProps> = ({ options, value, onChange }) => {
  const index = options.findIndex(opt => opt.label === value);
  const isMobile = useIsMobile();
  return (
    <SliderWrapper>
      <SliderHighlight index={index} />
      {options.map(opt => (
        <Option
          key={opt.label}
          active={opt.label === value}
          onClick={() => onChange(opt.label)}
        >
          {opt.label}
          {opt.hint && <span className="hint">{opt.hint}</span>}

        </Option>
      ))}
    </SliderWrapper>
  );
};
